import type { ReactNode } from "react";
import { Auth0Provider, type AppState } from "@auth0/auth0-react";
import { CONFIG } from "@/config";

// redirect_uri is the bare origin, so without this callback a post-login
// (or post-consent) redirect always lands on "/" - this sends the user back
// to wherever appState.returnTo says they came from.
function onRedirectCallback(appState?: AppState) {
  window.location.replace(appState?.returnTo ?? window.location.pathname);
}

const Auth0ProviderWithHistory = ({ children }: { children: ReactNode }) => {
  return (
    <Auth0Provider
      domain={CONFIG.Auth0Domain}
      clientId={CONFIG.Auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: CONFIG.Auth0Audience,
      }}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
